import { getAvailableModules, getEnabledModules } from '../../modules/shared/utils/paidModulesUtils';
import { ENTITY_PROFILE_TAB_NAME } from '../../modules/shared/constants/tabNames/ENTITY_PROFILE_TAB_NAME';
import { pathQueryParams } from '../../modules/shared/constants/pathQueryParams';

(function () {
    'use strict';

    angular.module('app.entityProfile').controller('EntityProfileController', EntityProfileController);

    EntityProfileController.$inject = [
        '$scope',
        '$routeParams',
        'utilService',
        'EntityService',
        'ModalService',
        'GeneralService',
        'PaymentService',
        'constants',
        'DateTimeUtil',
        'BaseUserUtils',
        'SolutionsService',
    ];

    function EntityProfileController($scope, $routeParams, utilService,
                                     EntityService, ModalService, GeneralService,
                                     PaymentService, constants,
                                     DateTimeUtil, BaseUserUtils, SolutionsService) {
        var vm = this;
        vm.dataEntryFields = constants.inbodyData;
        vm.inbodyTypes = constants.inbodyTypes;
        vm.patterns = constants.enums.patterns;
        vm.loggedInUser = utilService.getLoggedInUserData();
        vm.isSuperAdmin = utilService.getIsSuperAdmin();
        vm.isAdmin = utilService.getIsAdminRole();
        vm.isInbodyAdmin = utilService.getIsInbodyAdmin();
        vm.isSchoolLoggedIn = utilService.getLoggedInUserData().entityType === constants.enums.entityTypes.SCHOOL;
        vm.isParent = vm.loggedInUser.isLoggedByParent;
        vm.listOfTransactions = [];
        vm.entitySettings = {};
        vm.entityPassword = {};

        vm.TAB_NAME = ENTITY_PROFILE_TAB_NAME;
        vm.selectedTabName = null; // tabs should be initialized only after all necessary data is loaded

        vm.spinner = {active: false};
        vm.currentEntityAdmin = {};
        vm.assignedAtIsOpen = false;
        vm.assignedAt = null;
        vm.minDate = DateTimeUtil.minusYears(vm.currentDate, 100);
        vm.maxDate = DateTimeUtil.plusYears(vm.currentDate, 100);
        vm.loginId = {
            current: '',
            new: ''
        };
        vm.isActiveCalendarAvailable = false;
        vm.enabledModules = {}; 
        vm.paymentFlowType = {};
        vm.isFlowUnsupportedForInbodyAdmin = false;
        vm.billingType = {};
        vm.scanIqBillingType = {};
        vm.solutionTypeFlags = {};
        vm.availableSolutions = [];
        vm.activeSolution = null;
        vm.activeSolutionFlags = {};
        vm.isActiveSolutionUnavailable = false;

        vm.init = init;
        vm.setUserId = setUserId;
        vm.setEntityInfo = setEntityInfo;
        vm.initPageTab = initPageTab;
        vm.initCurrentEntity = initCurrentEntity;
        vm.processEntityInfo = processEntityInfo;
        vm.setIsActiveCalendarAvailable = setIsActiveCalendarAvailable;
        vm.setIsActiveCalendarEnabled = setIsActiveCalendarEnabled;
        vm.setSystemPaymentInfo = setSystemPaymentInfo;
        vm.setSolutionsInfo = setSolutionsInfo;
        vm.setActiveSolutionInfo = setActiveSolutionInfo;
        vm.validateActiveSolution = validateActiveSolution;

        vm.getLoginId = getLoginId;
        vm.saveLoginId = saveLoginId;
        vm.saveNewPassword = saveNewPassword;
        vm.setPassword = setPassword;
        vm.changePassword = changePassword;

        vm.addContact = addContact;
        vm.countContacts = countContacts;
        vm.removeContact = removeContact;

        vm.updateEntityContacts = updateEntityContacts;
        vm.getEntityAdmin = getEntityAdmin;
        vm.changeAvatar = changeAvatar;

        vm.init();

        $scope.$on(constants.enums.eventKeys.ACTIVE_SOLUTION_CHANGED, function () {
            vm.setActiveSolutionInfo();
            vm.validateActiveSolution();

            vm.selectedTabName = vm.TAB_NAME.BUSINESS_INFO;
        });

        async function init() {
            vm.setUserId();
            vm.setActiveSolutionInfo();
            vm.spinner.active = true;
            
            try {
                await Promise.all([
                    vm.setSystemPaymentInfo(),
                    vm.setSolutionsInfo(),
                    vm.initCurrentEntity(),
                ]);

                vm.validateActiveSolution();
                vm.initPageTab();
            } catch (error) {
                console.error('Error on init entity profile:', error);
            } finally {
                vm.spinner.active = false;
                utilService.applyAsyncFunc($scope);
            }
        }

        function setUserId() {
            if (vm.isAdmin) {
                vm.userId = vm.loggedInUser.gymId;
            } else {
                vm.userId = $routeParams.id;
            }
        }

        function changeAvatar(newAvatar) {
            BaseUserUtils.updateAvatar(newAvatar, vm.currentEntityAdmin);
        }

        function initPageTab() {
            const initialTab = $routeParams[pathQueryParams.initialTabName];
            const isInitialTabExist = initialTab && Object.values(vm.TAB_NAME).includes(initialTab);

            if (!isInitialTabExist) {
                vm.selectedTabName = vm.TAB_NAME.BUSINESS_INFO;
                return;
            }

            vm.selectedTabName = initialTab;
        }

        function initCurrentEntity() {
            if (vm.isSuperAdmin || vm.isInbodyAdmin) {
                return EntityService.getEntityById($routeParams.id).then(function (res) {
                    if (res.status === 200) {
                        vm.processEntityInfo(res.data);
                    }
                });
            } else if (vm.isAdmin) {
                return EntityService.getEntitiesOfAdmin().then(function (res) {
                    if (res.status === 200) {
                        vm.processEntityInfo(res.data.entities[0]);
                    }
                });
            }
        }

        function processEntityInfo(info) {
            vm.entitySettings = info;
            vm.entitySettings.monthlySupplementPrise = vm.entitySettings.monthlySupplementPrise / 100;
            vm.setEntityInfo();
            vm.setIsActiveCalendarAvailable();
            vm.setIsActiveCalendarEnabled();

            for (var i in vm.entitySettings.subscriptions) {
                vm.entitySettings.subscriptions[i].setUpEntityPrice = vm.entitySettings.subscriptions[i].setUpEntityPrice / 100;
                vm.entitySettings.subscriptions[i].setUpEkinPrice = vm.entitySettings.subscriptions[i].setUpEkinPrice / 100;
                vm.entitySettings.subscriptions[i].initInvoiceEntityPrice = vm.entitySettings.subscriptions[i].initInvoiceEntityPrice / 100;
                vm.entitySettings.subscriptions[i].initInvoiceEkinPrice = vm.entitySettings.subscriptions[i].initInvoiceEkinPrice / 100;
                vm.entitySettings.subscriptions[i].renewFeeEntityPrice = vm.entitySettings.subscriptions[i].renewFeeEntityPrice / 100;
                vm.entitySettings.subscriptions[i].renewFeeEkinPrice = vm.entitySettings.subscriptions[i].renewFeeEkinPrice / 100;
                vm.entitySettings.subscriptions[i].minChargeSetup = vm.entitySettings.subscriptions[i].minChargeSetup / 100;
                vm.entitySettings.subscriptions[i].minChargeInit = vm.entitySettings.subscriptions[i].minChargeInit / 100;
                vm.entitySettings.subscriptions[i].minChargeRenew = vm.entitySettings.subscriptions[i].minChargeRenew / 100;
            }
        }

        function setEntityInfo() {
            if (vm.isSuperAdmin || vm.isInbodyAdmin) {
                vm.getEntityAdmin();
            } else {
                vm.currentEntityAdmin = angular.copy(vm.loggedInUser);
            }
        }

        function getLoginId() {
            vm.spinner.active = true;
            EntityService.getLoginId(vm.userId)
              .then(res => {
                  if (res.status === 200) {
                      vm.loginId.current = res.data.loginId;
                  }
              }).finally(() => vm.spinner.active = false);
        }

        function saveLoginId(form) {
            vm.spinner.active = true;
            EntityService.saveLoginId(vm.userId, vm.loginId.new)
              .then(res => {
                  if (res.status === 200) {
                      ModalService.savedChanges();
                      vm.loginId.current = res.data.loginId;
                      vm.loginId.new = '';
                      form.$setPristine();
                      form.$setUntouched();
                  }
              }).finally(() => vm.spinner.active = false);
        }

        function saveNewPassword(form) {
            if ($routeParams.id) {
                const entityId = vm.currentEntityAdmin.id;
                vm.setPassword(entityId, form);
            } else {
                vm.changePassword(form);
            }
        }

        function getEntityAdmin(form) {
            vm.spinner.active = true;
            GeneralService.getEntityAdmin($routeParams.id).then(function (res) {
                vm.spinner.active = false;
                if (res.status === 200) {
                    vm.currentEntityAdmin = res.data;
                }
            });
        }

        function setPassword(id, form) {
            GeneralService.setPassword(id, vm.entityPassword).then(function (result) {
                if (result.status === 200) {
                    vm.entityPassword = {};
                    form.$setPristine();
                    form.$setUntouched();
                }
            });
        }

        function changePassword(form) {
            GeneralService.changePassword(vm.entityPassword).then(function (res) {
                if (res.data.message === 'Current password is wrong') {
                    form['currentPassword'].$setValidity('wrong', false);
                }
            });
        }

        function addContact() {
            vm.entitySettings.contacts.push({});
        }

        function countContacts() {
            var count = 0;
            vm.entitySettings.contacts.forEach(function (value) {
                count += value.id ? 1 : 0;
            });
            return count;
        }

        function removeContact(index) {
            if (vm.entitySettings.contacts[index].id) {
                if (vm.countContacts() > 1) {
                    EntityService.deleteEntityContact(vm.entitySettings.id, vm.entitySettings.contacts[index].id).then(function (res) {
                        if (res.status === 200) {
                            vm.entitySettings.contacts.splice(index, 1);
                        }
                    });
                } else {
                    ModalService.alert('Entity must have one contact at least.', 'Error');
                }
            } else {
                vm.entitySettings.contacts.splice(index, 1);
            }
        }

        function updateEntityContacts() {
            vm.spinner.active = true;
            EntityService.updateEntityContacts(vm.entitySettings.id, {contacts: vm.entitySettings.contacts}).then(function (res) {
                vm.spinner.active = false;
                if (res.status === 200) {
                    ModalService.savedChanges();
                    vm.entitySettings.contacts = res.data.contacts;
                }
            });
        }

        async function setIsActiveCalendarAvailable() {
            const availableModules = await getAvailableModules(vm.entitySettings.business_entity_type);
            vm.isActiveCalendarAvailable = availableModules.ACTIVE_CALENDAR;
            
            utilService.applyAsyncFunc($scope);
        }

        async function setIsActiveCalendarEnabled () {
            const enabledModules = await getEnabledModules(vm.entitySettings.id);
            vm.enabledModules = enabledModules;

            utilService.applyAsyncFunc($scope);
        }

        async function setSystemPaymentInfo() {
            const flags = await PaymentService.getSystemPaymentInfo(vm.userId);

            vm.paymentFlowType = flags.paymentFlowTypeFlags;
            vm.billingType = flags.billingTypeFlags;
            vm.scanIqBillingType = flags.scanIqBillingTypeFlags;

            // inbody admin works only with NEW_USER_FLOW_2024 entities (legacy tabs are not adapted for the role)
            vm.isFlowUnsupportedForInbodyAdmin = vm.isInbodyAdmin && !vm.paymentFlowType.NEW_USER_FLOW_2024;

            utilService.applyAsyncFunc($scope);
        }

        async function setSolutionsInfo() {
            const res = await SolutionsService.getSolutions(vm.userId);
            if (res.status === 200) {
                vm.solutionTypeFlags = res.data.solutionTypeFlags;
                vm.availableSolutions = res.data.solutions;
            }

            utilService.applyAsyncFunc($scope);
        }

        function setActiveSolutionInfo() {
            vm.activeSolution = utilService.getActiveSolution();
            vm.activeSolutionFlags = utilService.getActiveSolutionFlags();
        }

        function validateActiveSolution() {
            const activeSolution = vm.activeSolution;
            if (!activeSolution) {
                vm.isActiveSolutionUnavailable = false;
                return;
            }
            
            // Check if active solution is in available solutions
            vm.isActiveSolutionUnavailable = vm.availableSolutions.length > 0 && !vm.availableSolutions.includes(activeSolution);
        }
    }
})();
